module.exports = __webpack_public_path__ + "static/media/emaar-square.33766e5c.jpg";